/**
 * Where a quiz stop stands right now, from the instructor's side. Both
 * screens need this and each draws it differently — a pill above the slide
 * on the projector, a column of big buttons on the control panel — so what
 * they share is the reading, not the markup.
 *
 * 'none' the stop is not a quiz · 'closed' not open for answers yet ·
 * 'open' answers coming in · 'revealed' the answer is up.
 */
export function quizPhase(room, stop) {
  if (!stop || stop.kind !== 'quiz') return 'none';
  const live = room.question && room.question.orderIndex === stop.order;
  if (!live) return 'closed';
  return room.question.revealed ? 'revealed' : 'open';
}

/** Answered / total for the live question, as the instructor watches it. */
export function answerCount(room) {
  return {
    answered: room.question?.answeredCount ?? 0,
    total: room.question?.totalPlayers ?? room.connectedCount ?? 0,
  };
}
